import React from "react";

import { Checkbox } from "./ui/checkbox";

/**
 * Unchecked box until POST /api/profile/disclaimer succeeds.
 * After a current record, the same sentence is footer text.
 */
const DisclaimerNotice = ({
  needsCheckbox,
  text,
  saving,
  onAccept,
  className,
}) => {
  const frame = className || "mt-4 pt-4 border-t";

  if (needsCheckbox) {
    return (
      <div className={`flex items-start gap-3 ${frame}`} data-testid="disclaimer-ack-block">
        <Checkbox
          id="disclaimer-ack"
          data-testid="disclaimer-ack-checkbox"
          checked={false}
          disabled={saving}
          onCheckedChange={(checked) => {
            if (checked === true) onAccept?.();
          }}
        />
        <label
          htmlFor="disclaimer-ack"
          className="text-xs md:text-sm text-muted-foreground leading-relaxed cursor-pointer"
          data-testid="disclaimer-ack-text"
        >
          {text}
        </label>
      </div>
    );
  }

  if (!text) return null;

  return (
    <p
      className={`text-xs md:text-sm text-muted-foreground leading-relaxed ${frame}`}
      data-testid="disclaimer-notice"
    >
      {text}
    </p>
  );
};

export default DisclaimerNotice;
